import React, { type ReactElement } from 'react';

import { type PreparationProcessType } from '@/common/types/preparation-process.type';
import { type ProductStatusType } from '@/common/types/product-status.type';
import { type TransactionStatus } from '@/common/types/transaction-status.type';
import { Tag as AntTag, type TagProps as AntTagProps } from 'antd';

export interface TagProps extends AntTagProps {
  type?:
    | PreparationProcessType
    | TransactionStatus
    | ProductStatusType
    | 'FILTER';
}

const productDefaultTag = 'bg-black-default text-white';
const destructiveDefaultTag = 'bg-error-10 text-error-100';

const tagStyles = {
  // ORDERS TAGS
  PENDING: 'bg-tangerine-50 text-tangerine-500',
  PROCESSING: 'bg-secondary-50 text-secondary-400',
  SHIPPED: 'bg-Green-50 text-Green-600',
  REJECTED: destructiveDefaultTag,
  REJECTEDBYADMIN: destructiveDefaultTag,
  CANCELLED: destructiveDefaultTag,
  AUTOREJECTED: destructiveDefaultTag,
  CANCELLEDBYADMIN: destructiveDefaultTag,
  CANCELLEDBYVENDOR: destructiveDefaultTag,

  // TRAANSACTION
  CONFIRMED: 'bg-Green-100 text-Green-600',
  UNCONFIRMED: destructiveDefaultTag,
  PENDINGTRANSACTION: 'bg-secondary-50 text-secondary-400',
  // PRODUCT TAGS
  PRODUCTPENDING: productDefaultTag,
  OUTOFSTOCK: productDefaultTag,
  ARCHIVED: productDefaultTag,
  NOTAPPROVED: 'bg-red-default text-white',
  APPROVED: '',
  // FILTER
  FILTER:
    'tag ltr m-0 h-[36px] w-fit rounded-md border-none !bg-blue-25 px-2 py-[6px] text-xs !text-blue-default ',
};

export default function Tag({
  children,
  type = 'PRODUCTPENDING',
  className,
  ...rest
}: TagProps): ReactElement {
  return (
    <AntTag
      className={` flex h-5 items-center justify-center rounded border-none px-2 py-0.5 text-2xs font-medium ${className} ${tagStyles[type]}`}
      {...rest}
    >
      {children}
    </AntTag>
  );
}
